import { useEffect, useState } from 'react'
import type { Observable } from 'rxjs'

/**
 * @internal
 */
export function useObservableState<T>(
  observable: Observable<T> | undefined,
  startWith: T,
  resetWhenObservableChanges = true,
) {
  const [state, setState] = useState<T>(startWith)

  useEffect(() => {
    if (resetWhenObservableChanges) {
      setState(startWith)
    }
    // observable state doesn't run in SSR
    if (typeof window === 'undefined' || !observable) return
    const subscription = observable.subscribe(setState)
    return () => subscription.unsubscribe()
  }, [observable, resetWhenObservableChanges])

  return state
}
